
import React, { useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { WaitlistProvider } from '../context/WaitlistContext';
import HeroSection from '../components/landing/HeroSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import CTASection from '../components/landing/CTASection';
import WaitlistSection from '../components/landing/WaitlistSection';
import LandingFooter from '../components/landing/LandingFooter';
import PerformanceOptimizations from '../components/PerformanceOptimizations';

const Index = () => {
  const { isAuthenticated } = useUser();
  
  // Update document title to match new branding
  useEffect(() => {
    document.title = 'Hormony - Get Back in Tune with You';
    
    // Preload critical hero image - ensure we clean up on unmount
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = '/lovable-uploads/ac7da958-8971-47d6-8588-0611fa790b37.png';
    // Use a valid attribute for fetch priority
    if ('fetchPriority' in preloadLink) {
      // @ts-ignore - TypeScript might not recognize fetchPriority yet
      preloadLink.fetchPriority = 'high';
    }
    
    // Check if preload link already exists
    const existingLink = document.querySelector(`link[rel="preload"][href="${preloadLink.href}"]`);
    if (!existingLink) {
      document.head.appendChild(preloadLink);
    }
    
    return () => {
      // Clean up the preload link when component unmounts
      if (document.head.contains(preloadLink)) {
        document.head.removeChild(preloadLink);
      }
    };
  }, []);
  
  return (
    <WaitlistProvider>
      <div className="min-h-screen flex flex-col bg-white overflow-hidden">
        {/* Add PerformanceOptimizations component to help with image loading */}
        <PerformanceOptimizations />
        <HeroSection isAuthenticated={isAuthenticated} />
        <FeaturesSection />
        <TestimonialsSection />
        <CTASection isAuthenticated={isAuthenticated} />
        
        {/* Only show WaitlistSection if user is not authenticated */}
        {!isAuthenticated && <WaitlistSection />}
        
        <LandingFooter />
      </div>
    </WaitlistProvider>
  );
};

export default Index;
